import { useEffect, useState } from "react";
import { useLocation } from "@tanstack/react-router";
import { toast } from "sonner";
import { getAuthErrorToast, type AuthErrorToast } from "@/frontend/utils/auth-errors";

export function AuthErrorToastHandler() {
  const location = useLocation();
  const [pendingError, setPendingError] = useState<AuthErrorToast | null>(null);

  useEffect(() => {
    if (pendingError) return;

    const params = new URLSearchParams(window.location.search);
    const nextError = getAuthErrorToast(
      params.get("error"),
      params.get("error_description"),
    );

    if (nextError) {
      setPendingError(nextError);
    }
  }, [location.hash, location.pathname, location.searchStr, pendingError]);

  useEffect(() => {
    if (!pendingError) return;

    toast.error(pendingError.title, {
      description: pendingError.description,
    });

    const params = new URLSearchParams(window.location.search);
    params.delete("error");
    params.delete("error_description");
    const nextSearch = params.toString();
    const cleanUrl =
      `${window.location.pathname}${nextSearch ? `?${nextSearch}` : ""}${window.location.hash}`;

    window.history.replaceState(window.history.state, "", cleanUrl);
    setPendingError(null);
  }, [pendingError]);

  return null;
}
